import React from 'react';

const RequestServices = () => {
  return (
    <section className="undefined RequestService-sec">
      <div className="px-6 lg:px-8 max-w-7xl mx-auto mt-14 md:mt-24 lg:mt-[10.5rem] mb-1">
        <div className="undefined flex flex-col justify-between gap-x-8 gap-y-4 bg-gradient-to-r from-[#f6f6f6b3] to-[#dfe2e659] p-4 md:p-6  md:flex-row md:items-center lg:pl-11 lg:pr-8 rounded-2xl md:rounded-full border">
          <h4 className="customh4 text-black font-bold text-2xl xl:text-3xl 2xl:text-4xl tracking-[0px] md:w-[70%] lg:w-[75%] xl:w-[80%]">
            Kickstart your <span className="text-theme">Mobile App</span>{" "}
            project today!
          </h4>
          <div className="flex">
            <button className="header-module--buttonChange--18e23 bg-black text-white 2xl:max-w-[195px] items-center px-6 md:px-11 h-[40px] md:h-12 border-transparent rounded-full font-extrabold text-sm">
              <span className="pb-[3px] md:pb-1.5">Get a Quote</span>
              <span className="pb-[3px] md:pb-1.5">Get a Quote</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RequestServices;
  